module.exports = __webpack_public_path__ + "img/event3.ea4c8de4.jpg";